<template>
    <div class="animated fadeIn">
        <b-card>
            <template v-slot:header>
                <h5>Pelunasan</h5>
            </template>
            <b-form>
                <div class="form-content-wrapper">
                    <div v-if="fullAccess == 1">
                        <b-form-group label="Cabang">
                            <b-form-checkbox 
                                v-model="input.allCabang"
                                name="allCabang"
                                class="mb-2"
                            >
                                Semua Cabang
                            </b-form-checkbox>
                            <div class="mr-2">
                                <multiselect
                                    name="cabang"
                                    :disabled=input.allCabang
                                    v-model="input.cabang" 
                                    :options="cabangOption" 
                                    :internal-search="true"
                                    :allow-empty="true"
                                    deselect-label=""
                                    select-label=""
                                    label="name"
                                    track-by="name"
                                    placeholder="-- Pilih Cabang --"
                                />
                            </div>
                        </b-form-group>
                    </div>
                    <b-form-group label="Cabang" v-else>
                        <div class="mr-2">
                            <multiselect
                                name="cabang"
                                v-model="input.cabang" 
                                :options="cabangOption" 
                                :internal-search="true"
                                :allow-empty="true"
                                deselect-label=""
                                select-label=""
                                label="name"
                                track-by="name"
                                placeholder="-- Pilih Cabang --"
                            />
                        </div>
                    </b-form-group>

                    <b-form-group label="Tipe Pinjaman">
                        <b-form-select class="mr-2" v-model="input.tipePinjaman" name="tipePinjaman" :options="tipeOption" value-field="id" text-field="name">
                            <template v-slot:first>
                                <b-form-select-option :value="null" disabled>-- Pilih Tipe Pinjaman --</b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-form-group>

                    <b-form-group class="small-input-date" label="Harian">
                        <div class="d-flex search-input-wrapper">
                            <b-form-input class="mr-2" v-model="input.startDate" name="startDate" type="date"></b-form-input>
                            <span class="mr-2 d-flex align-items-center">s/d</span>
                            <b-form-input v-model="input.endDate" name="endDate" type="date"></b-form-input>
                        </div>
                    </b-form-group>
                </div>
                <div class="form-wrapper-btn">
                    <b-button v-if="fullAccess == 1" name="downloadLaporan" variant="pgiBtn" @click="confirmLaporanDownload">
                        <i class="fa fa-download mr-2"></i>
                        Download Excel
                    </b-button>
                </div>
            </b-form>
        </b-card>

        <ModalConfirm id="modal-confirm-cetak" title="Confirm Cetak Laporan Pelunasan" :isSubmitting="isSubmitting" desc="Apakah anda yakin untuk mencetak laporan pelunasan ini?" @submit="openLaporanDownload" />
        <b-modal id="modal-download-excel" centered title="Download Excel" hide-footer no-close-on-backdrop>
            <div class="text-center" v-if="isLoading == true">
                <b-spinner class="align-middle mb-4"></b-spinner>
                <p class="mb-0">Sedang memproses, mohon menunggu...</p>
            </div>
            <div class="show-btn-download" v-else>
                <p class="">
                    Silakan download dengan klik tombol dibawah ini :
                </p>
                <b-button variant="pgiBtn" class="mb-0 download-btn">
                    <a v-bind:href="$baseFilePath + filePathDownload" download>
                        <i class="fa fa-download mr-2"></i>
                        Download Excel
                    </a>
                </b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: 'kas-masuk',
    data(){
        return{
            isSubmitting: false,
            cabang: null,
            fullAccess: null,
            input: {
                allCabang: false,
                cabang: null,
                tipePinjaman: null,
                startDate: null,
                endDate: null,
            },
            cabangOption: [],
            tipeOption: [
                { id: "GE", name: "Gadai Elektronik" },
                { id: "GB", name: "Gadai BPKB" },
                { id: "GG", name: "Gadai Emas" }
            ],
            dateType: "harian",

            //
            isLoading: false,
            filePathDownload: "",
            query: "",
        }
    }, 
    methods: {

        //----------------- Fungsi Inisialisasi -----------------

        init(){
            this.$axios.get('laporan/durasi-laporan').then(response => {
                this.fullAccess = response.data.id
                if(response.data.id != 1){
                    this.cabangOption = this.$helper.getAllCabang()
                }else{
                    this.$axios.get("cabang/all-selection").then(response => {
                        response.data.forEach((element) => {
                            this.cabangOption.push(element)
                        })
                    })
                }
            })
        },

        confirmLaporanDownload(){
            if(this.input.allCabang == false && this.input.cabang == null){
                this.$helper.toastErr(this, "Mohon isi data cabang terlebih dahulu!")
            }else if(!this.$helper.isNotNullAndNotEmpty(this.input.tipePinjaman)){
                this.$helper.toastErr(this, "Mohon isi data tipe pinjaman terlebih dahulu!")
            }else if(!this.$helper.isNotNullAndNotEmpty(this.input.startDate) || !this.$helper.isNotNullAndNotEmpty(this.input.endDate)){
                this.$helper.toastErr(this, "Mohon lengkapi periode harian untuk cetak laporan!")
            }else if(this.$helper.isNotNullAndNotEmpty(this.input.startDate && this.$helper.isNotNullAndNotEmpty(this.input.endDate)) && (Date.parse(this.input.endDate) < Date.parse(this.input.startDate))){
                this.$helper.toastErr(this, "Tanggal akhir periode harian laporan lebih kecil daripada tanggal mulai!")
            }else{
                this.$bvModal.show("modal-confirm-cetak")
            }         
        },

        openLaporanDownload() {
            this.isLoading = true
            this.isSubmitting = true
            this.$bvModal.show('modal-download-excel')
            this.$bvModal.hide('modal-confirm-cetak')
            setTimeout(() => { this.axiosLaporanDownload() }, 500)
        },

        axiosLaporanDownload(){
            if(this.input.cabang == null){
                this.query = "?cabangId=0&tipePinjaman="+this.input.tipePinjaman+"&startDate="+this.input.startDate
                            +"&endDate="+this.input.endDate+"&allCabang="+this.input.allCabang
            }else{
                this.query = "?cabangId="+this.input.cabang.id+"&tipePinjaman="+this.input.tipePinjaman+
                            "&startDate="+this.input.startDate+"&endDate="+this.input.endDate+
                            "&allCabang="+this.input.allCabang
            }
         
            this.$axios.get(`laporan/pelunasan/${this.query}`).then(response => {
                this.filePathDownload = response.data
           
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$bvModal.hide('modal-download-excel')
                this.$helper.toastErr(this, error.response.data.reason)
            })
            .finally(() => {
                this.isSubmitting = false
                this.isLoading = false
            })
        },
    },

    created(){
        this.init()
    }
}
</script>